import React, { useEffect, useState } from 'react';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import PageHeading from '../../components/PageHeading/PageHeading';
import { apiUrl, colors } from '../../config/constants';
import axiosInstance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import { errorMessage } from '../../config/errorsMsg';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import {
  updateFlashBar,
  updateIsLoading,
  updateTokenInfo,
  update_breadcrumb,
} from '../../redux/action';
import { errorMessageAutoCapitalize, handlingNullData } from '../../config/helpers';
import { useNavigate } from 'react-router-dom';
import { successMessage } from '../../config/keyword';

interface GetUserResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  profileImage: string;
  organizationName: string;
}
type UpdateProps = {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
};
type UserResponseProps = {
  organizationId: string;
  organizationRoleId: string;
  organizationRoleName: string;
  profileImage: string;
  organizationName: string;
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: number;
};
const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const tokenInfo = useSelector((state: StateProps) => state.tokenInfo);
  const [isEdit, setIsEdit] = useState(true);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [newpassword, setNewPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [confirmNewPassword, setConfirmPassword] = useState('');
  const [minMaxChar, setMinMaxChar] = useState(false);
  const [upperCase, setUpperCase] = useState(false);
  const [lowercase, setLowercase] = useState(false);
  const [numcheck, setNumCheck] = useState(false);
  const [specialChar, setSpecialChar] = useState(false);
  const [confirmPasswordMatch, setConfirmPasswordMach] = useState(false);
  const [changePasswordTab, setChangePasswordTab] = useState(false);
  const [formError, setFormError] = useState<any>({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [emptyImageError, setEmptyImageError] = useState<string | undefined>();
  const [state, setState] = useState<UserResponseProps>();
  const [userDetail, setUserDetail] = useState<GetUserResponse>({
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    profileImage: '',
    organizationName: '',
  });
  const { firstName, lastName, email, profileImage, organizationName } = userDetail;
  useEffect(() => {
    getUserData();
    const breadcrumb = [{ path: '/profile', name: 'Profile' }];
    dispatch(update_breadcrumb(breadcrumb));
  }, []);
  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      updateUser();
    }
  }, [formError]);

  const dataToStore = 'Profile';
  localStorage.setItem('breadcrumbData', dataToStore);

  const handleUpdate = () => {
    setFormError(userEditValidation());
    setIsSubmit(true);
  };

  const handleUplaodImage = () => {
    if (selectedImage != null) {
      uploadProfilePicApi(selectedImage);
    }
  };
  const newPasswordChangHandler = (value: string) => {
    setNewPassword(value);
    setMinMaxChar(value.length >= 12 && value.length <= 36);
    setUpperCase(/[A-Z]/.test(value));
    setLowercase(/[a-z]/.test(value));
    setNumCheck(/[0-9]/.test(value));
    setSpecialChar(/[^a-zA-Z0-9]/.test(value));
    setConfirmPasswordMach(value == confirmNewPassword && value != '');
  };
  const handleChangePassworTab = () => {
    setChangePasswordTab(!changePasswordTab);
    clearPassword();
  };
  const handleCancelPasswordChange = () => {
    setChangePasswordTab(false);
    clearPassword();
  };
  const handleConfirmPasswordChange = (value: string) => {
    setConfirmPassword(value);
    setConfirmPasswordMach(newpassword == value && newpassword != '');
  };
  const userEditValidation = () => {
    const error: any = {};
    if (!firstName) {
      error.firstName = errorMessage.emptyFirstName;
    } else if (
      (firstName.length > 0 && firstName.length < 4) ||
      firstName.length > 64
    ) {
      error.firstName = errorMessage.userFirstNameLength;
    }
    if (!lastName) {
      error.lastName = errorMessage.emptyLastName;
    } else if (
      (lastName.length > 0 && lastName.length < 4) ||
      lastName.length > 64
    ) {
      error.lastName = errorMessage.userLastNameLength;
    }
    return error;
  };
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setUserDetail({ ...userDetail, [event.target.name]: event.target.value });
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required  `,
      });
    }
  };
  const handleUpdateCancel = () => {
    getUserData();
    setIsEdit(true);
    setIsSubmit(false);
    setSelectedImage(null);
    setEmptyImageError(undefined);
    setFormError({});
  };
  const handleEdit = () => {
    setIsEdit(!isEdit);
  };

  const imageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const allowedFileTypes = ['.jpg', '.jpeg', '.png', '.PNG', '.JPEG', 'JPG'];
    if (e.target.files && e.target.files.length > 0) {
      const fileExtension = e.target.files[0].name.split('.').at(-1);
      if (allowedFileTypes.includes(`.${fileExtension}`)) {
        setSelectedImage(e.target.files[0]);
        setEmptyImageError(undefined);
      } else {
        setEmptyImageError(`Choose ${allowedFileTypes.join(', ')} format`);
        setSelectedImage(null);
      }
    } else {
      setSelectedImage(null);
      setEmptyImageError('Please Select A Image');
    }
  };
  const resetUploadImage = () => {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  };
  const handlePasswordChange = () => {
    const request = {
      currentPassword: currentPassword,
      newPassword: newpassword,
      confirmNewPassword: confirmNewPassword,
    };
    updatePassword(request);
  };

  const clearPassword = () => {
    setCurrentPassword('');
    setNewPassword('');
    setConfirmPassword('');
    setMinMaxChar(false);
    setUpperCase(false);
    setLowercase(false);
    setNumCheck(false);
    setConfirmPasswordMach(false);
    setSpecialChar(false);
  };

  const updatePassword = (data: UpdateProps) => {
    axiosInstance
      .put('/account/password', data)
      .then((response) => {
        if (response.status === 200) {
          gotUpdatePasswordResponse(response.data);
        }
      })
      .catch(() => {
        clearPassword();
        const obj = {
          isOpen: true,
          message: 'Something went wrong!',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const gotUpdatePasswordResponse = (data: {
    isSuccess: boolean;
    message: string;
  }) => {
    const { isSuccess, message } = data;
    if (isSuccess) {
      const obj = {
        isOpen: true,
        message: successMessage.PASSWORD_UPDATE,
        type: flashBarTheme.SUCCESS,
      };
      dispatch(updateFlashBar(obj));

      setChangePasswordTab(!changePasswordTab);
      clearPassword();
    } else {
      clearPassword();
      const obj = {
        isOpen: true,
        message: message,
        type: flashBarTheme.ERROR,
      };
      dispatch(updateFlashBar(obj));
    }
  };
  const getUserData = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .get(`/users/${userInfo.id}`)
      .then((response) => {
        if (response.status === 200) {
          setUserDetail(response.data);

          setState(response.data);

          dispatch(
            updateTokenInfo({
              ...tokenInfo,
              userInfo: { ...userInfo, profileImage: response.data.profileImage },
            })
          );
        }
        dispatch(updateIsLoading(false));
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const uploadProfilePicApi = (imageFile: File) => {
    const formData = new FormData();
    formData.append('ImageFile', imageFile);
    dispatch(updateIsLoading(true));
    axiosInstance
      .put(`/account/profile-image`, formData)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.PROFILE_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          resetUploadImage();
          setSelectedImage(null);
          setEmptyImageError(undefined);
          getUserData();

          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        setIsEdit(true);
      });
  };
  const updateUser = () => {
    const obj = { firstName: firstName, lastName: lastName };
    axiosInstance
      .put(`/account`, obj)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.USER_UPDATE,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getUserData();
          setIsEdit(true);
          setEmptyImageError(undefined);
        }
      })
      .catch(() => {
        const obj = {
          isOpen: true,
          message: errorMessage.oops,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));

        setIsEdit(true);
      });
  };
  const onClickMyActivity = () => {
    localStorage.setItem('isFrom', 'profile');
    navigate(`/userActivity/${userDetail.id}`);
  };
  return (
    <>
      <div className="p-2 ">
        <div className="">
          <PageHeading label="Profile" />
          <div className="bg-white rounded-sm p-4 shadow-lg">
            <div className={`text-[20px] mb-2 ${colors.primaryText} font-semibold`}>
              Profile Information
            </div>
            {isEdit ? (
              <div className="xl:flex items-center ">
                <img
                  className="w-40 h-40 bg-cover bg-center"
                  src={`${apiUrl}/${profileImage}`}
                  alt="profileimg"
                />

                <div className={`xl:pl-32`}>
                  <div className="flex">
                    <div className="font-normal min-w-[100PX] pb-2 lg:pb-3">
                      First name
                    </div>
                    <div className="font-normal pl-10 lg:pl-24">
                      {handlingNullData(firstName)}
                    </div>
                  </div>
                  <div className="flex">
                    <div className="font-normal min-w-[100PX] pb-2 lg:pb-3">
                      Last name
                    </div>
                    <div className="font-normal pl-10 lg:pl-24">
                      {handlingNullData(lastName)}
                    </div>
                  </div>
                  <div className="flex">
                    <div className="font-normal min-w-[100PX] pb-2 lg:pb-3">
                      Email id
                    </div>
                    <div className="font-normal pl-10 lg:pl-24">
                      {handlingNullData(email)}
                    </div>
                  </div>
                  <div className="flex">
                    <div className="font-normal min-w-[100PX] pb-2 lg:pb-3">
                      Organization Name
                    </div>
                    <div className="font-normal pl-1 lg:pl-[60px]">
                      {handlingNullData(organizationName)}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="flex md:justify-around items-center flex-col md:flex-row border-b-2">
                  <div>
                    {selectedImage ? (
                      <img
                        src={URL.createObjectURL(selectedImage)}
                        alt="Thumb"
                        className=" my-2 w-40 h-40"
                      />
                    ) : (
                      <img
                        src={`${apiUrl}/${profileImage}`}
                        alt="Thumb"
                        className=" my-2 w-40 h-40"
                      />
                    )}
                  </div>

                  <div className="flex items-center justify-center flex-col md:flex-row gap-4 md:gap-0">
                    <div className="flex flex-col">
                      {' '}
                      <input
                        accept="image/*"
                        type="file"
                        id="fileInput"
                        className="cursor-pointer pt-2 md:pt-0 block w-full text-sm text-slate-500 file:mr-4 file:py-1 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#438cab] file:text-white hover:file:bg-[#dbeafe] hover:file:text-[#27374d]"
                        onChange={imageChange}
                      />
                      <div className="text-sm text-[red] ml-2 mt-1">
                        {emptyImageError}
                      </div>
                    </div>
                    <Button
                      label="Upload"
                      buttonType="primary"
                      type="button"
                      onClick={() => handleUplaodImage()}
                      disabled={selectedImage ? false : true}
                    />
                  </div>
                </div>
                <div className="flex md:justify-around items-center flex-col md:flex-row mt-4">
                  <div className="">
                    <Input
                      label={'First Name'}
                      name="firstName"
                      placeholder={'Enter First Name'}
                      type={'text'}
                      value={firstName}
                      onChange={(event) => {
                        handleChange(event);
                      }}
                      error={formError?.firstName}
                    />
                    <Input
                      label={'Last Name'}
                      placeholder={'Enter Last Name'}
                      type={'text'}
                      value={lastName}
                      name="lastName"
                      onChange={(event) => {
                        handleChange(event);
                      }}
                      error={formError?.lastName}
                    />
                  </div>
                  <div className="flex md:px-4 px-0 items-center justify-center flex-col md:flex-row gap-4">
                    <Button
                      label="Update"
                      buttonType="primary"
                      type="button"
                      onClick={() => handleUpdate()}
                      disabled={
                        firstName === state?.firstName &&
                        lastName === state?.lastName
                      }
                    />
                    <Button
                      label="Cancel"
                      buttonType="danger"
                      type="button"
                      onClick={() => handleUpdateCancel()}
                    />
                  </div>
                </div>
              </>
            )}

            {isEdit && (
              <div className="flex justify-between mt-5">
                <Button
                  label="Change Password"
                  buttonType="danger"
                  type="button"
                  onClick={() => handleChangePassworTab()}
                />
                <div className="flex space-x-2">
                  <Button
                    label="Edit"
                    buttonType="primary"
                    type="button"
                    onClick={() => handleEdit()}
                  />
                  <Button
                    label="My activity"
                    buttonType="primary"
                    type="button"
                    onClick={onClickMyActivity}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="p-2">
        {changePasswordTab && (
          <div className="bg-white shadow-lg p-4 mt-2 rounded-xl">
            <div className={`text-[20px] ${colors.primaryText} font-semibold pb-3`}>
              Change Password
            </div>
            <div className="sm:flex items-center border-t-2 border-[#176b87] w-full ">
              <div className="w-full">
                <div className="my-1 text-slate-600 text-md font-bold">
                  Password mandoatory conditions:
                </div>
                <div className="flex items-center">
                  {minMaxChar ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    Minimum 12 and maximum 38 characters
                  </div>
                </div>
                <div className="flex items-center">
                  {confirmPasswordMatch ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    Match with confirm password
                  </div>
                </div>
                <div className="my-1 text-slate-600 text-md font-bold">
                  Password good to have conditions:
                </div>
                <div className="flex items-center">
                  {upperCase ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    At least 1 uppercase letter (A-Z)
                  </div>
                </div>
                <div className="flex items-center">
                  {lowercase ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    At least 1 lowercase letter (a-z)
                  </div>
                </div>
                <div className="flex items-center">
                  {numcheck ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    At least 1 number (0-9)
                  </div>
                </div>
                <div className="flex items-center">
                  {specialChar ? (
                    <div>
                      <i className="fa-solid fa-check mr-2 text-green-600"></i>
                    </div>
                  ) : (
                    <div>
                      <i className="fa-solid fa-xmark mr-2 text-red-600"></i>
                    </div>
                  )}
                  <div className="my-1 text-slate-600 text-sm">
                    At least 1 special character
                  </div>
                </div>
              </div>
              <div className="w-full">
                <div className="my-1 px-4 ">
                  <div className="my-4">
                    <Input
                      label="Current Password"
                      type="password"
                      placeholder="Enter current password"
                      value={currentPassword}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setCurrentPassword(e.target.value)
                      }
                    />
                  </div>
                  <div className="my-4">
                    <Input
                      label="New Password"
                      type="password"
                      placeholder="Enter a new password"
                      value={newpassword}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        newPasswordChangHandler(e.target.value)
                      }
                    />
                  </div>
                  <div className="my-4">
                    <Input
                      label="Confirm Password"
                      type="password"
                      placeholder="Re-enter new password"
                      value={confirmNewPassword}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        handleConfirmPasswordChange(e.target.value)
                      }
                    />
                  </div>
                  <div className="flex items-center mt-6">
                    <div className="mr-4">
                      <Button
                        disabled={!(minMaxChar && confirmPasswordMatch)}
                        label={'submit'}
                        type={'button'}
                        buttonType={'primary'}
                        onClick={() => handlePasswordChange()}
                      />
                    </div>
                    <div>
                      <Button
                        label={'cancel'}
                        type={'button'}
                        buttonType={'danger'}
                        onClick={() => handleCancelPasswordChange()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
